var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _rect5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _path25, _path26, _path27, _path28, _circle, _circle2, _path29, _polygon, _rect6, _path30, _circle3, _rect7, _path31, _circle4, _rect8, _path32, _circle5, _rect9, _path33, _circle6, _rect10, _path34, _path35, _path36, _path37, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 713,
    height: 847.85985,
    viewBox: "0 0 713 847.85985",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cabin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.08,603.40047a122.5375,122.5375,0,0,0,5.13995,12.38v.01q2.355,4.92,5.12006,9.59H707.36v.43q2.925-4.875,5.38-10.04a120.09911,120.09911,0,0,0,5.14-12.37Zm5.42,12.25v-2H712.49v2Zm16.76,26.54H695.7a125.03246,125.03246,0,0,0,10.71-14.81H493.55A125.04086,125.04086,0,0,0,504.26,642.19051Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M721.24,592.1805c-.77,3.13-1.67,6.2-2.68,9.22H481.4c-1.01-3.02-1.91-6.09-2.68-9.22Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M721.39,591.59047v-1.41H478.57v1.41q-1.27506-5.22-2.11-10.63H723.5Q722.675,586.36052,721.39,591.59047Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.02,567.7405v2H724.71c-.19,3.11-.49,6.18-.92,9.22H476.17c-.42-3.02-.73-6.08-.91-9.18-.18-2.62-.26-5.26-.26-7.93,0-1.8.04-3.59.11-5.37v-.02q.25506-5.685.98-11.22v-.01q.63-4.635,1.56994-9.16H721.9v-1.82q1.22992,5.43,1.96,11.04H476.53v2H724.11q.495,4.185.7,8.44l.03.78H476.28v2H724.91c.04,1.11005.05,2.22.05,3.34,0,1.98-.05,3.94-.14,5.89Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M721.86,534.07051H478.1q1.065-4.68007,2.47-9.22H719.35v-.11C720.31,527.80049,721.14,530.91048,721.86,534.07051Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M718.75,522.85048H481.21q1.86-5.7,4.25-11.14v1.91H714.5v-1.9Q716.885,517.15046,718.75,522.85048Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M714.45,511.6205H485.5q2.07-4.71,4.53-9.22H709.66v-.5Q712.27,506.64052,714.45,511.6205Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M708.82,500.40047H491.13a125.00629,125.00629,0,0,1,217.69,0Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M478.57,591.59047a5.65309,5.65309,0,0,0,.15.59h-.15Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M721.39,591.59047v.59h-.15A5.66578,5.66578,0,0,0,721.39,591.59047Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M724.96,567.7405v2h-.25c.02-.25.04-.5.05-.75.02-.42.04-.83.06-1.25Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M724.96,556.51045v2h-.05c-.01-.67-.04-1.32995-.06994-2Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M721.9,534.07051v.18c-.01-.06-.03-.12-.04-.18Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M485.46,511.6205h.04a.35671.35671,0,0,1-.04.09Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M714.5,511.6205v.1a.93491.93491,0,0,0-.05-.1Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 254.71045,
    y: 462.35773,
    width: 203.53857,
    height: 2,
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 263.12744,
    y: 451.13507,
    width: 187.21436,
    height: 2,
    opacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 274.60547,
    y: 439.91242,
    width: 163.74902,
    height: 2,
    opacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 530.60291,
    y: 455.63704,
    width: 136.20288,
    height: 2,
    transform: "translate(-244.39073 -25.64963) rotate(-0.11191)",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 278.67409,
    y: 469.36066,
    width: 59.68421,
    height: 132.24798,
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M305.97756,481.81258h2.52666a14.04031,14.04031,0,0,1,14.04031,14.04031v19.88043a0,0,0,0,1,0,0H291.93725a0,0,0,0,1,0,0V495.85289A14.04031,14.04031,0,0,1,305.97756,481.81258Z",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M415.14371,468.20378h0a15.30363,15.30363,0,0,1,15.30363,15.30363v24.996a0,0,0,0,1,0,0H399.84008a0,0,0,0,1,0,0v-24.996A15.30363,15.30363,0,0,1,415.14371,468.20378Z",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M716.79757,546.03576a31.9499,31.9499,0,0,1-.199,3.57085H599.97976V542.975H716.64962Q716.795,544.49774,716.79757,546.03576Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M616.71516,523.64925l1.13367-1.752a26.26686,26.26686,0,0,0-1.16307-2.72264l-.73307.59209.58044-.897c-.55316-1.08889-.98843-1.77495-.98843-1.77495a25.173,25.173,0,0,0-3.0332,7.37624l1.45476,2.24827-1.61048-1.30078a10.62658,10.62658,0,0,0-.08836,1.33255c0,4.49266,1.46729,8.13468,3.27728,8.13468s3.27729-3.642,3.27729-8.13468a13.9907,13.9907,0,0,0-.74974-4.19782Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#ed7342"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M624.73942,527.54413l2.0405-.43725a26.26669,26.26669,0,0,0,1.10277-2.74761l-.937-.09969,1.04474-.22386c.37881-1.16111.55615-1.954.55615-1.954a25.173,25.173,0,0,0-7.36059,3.071l-.5611,2.61843-.219-2.05857a10.62774,10.62774,0,0,0-1.00473.87977c-3.17679,3.1768-4.71456,6.78962-3.4347,8.06948s4.89268-.25791,8.06948-3.4347a13.99068,13.99068,0,0,0,2.43816-3.49845Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#ed7342"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M625.48473,544.92845c-4.73171.30267-9.8874-.0176-15.37219,0V532.37089a55.40742,55.40742,0,0,0,15.37219,0Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M693.7435,523.64925l1.13367-1.752a26.26686,26.26686,0,0,0-1.16307-2.72264l-.73307.59209.58044-.897c-.55316-1.08889-.98843-1.77495-.98843-1.77495a25.173,25.173,0,0,0-3.0332,7.37624l1.45476,2.24827-1.61048-1.30078a10.62658,10.62658,0,0,0-.08836,1.33255c0,4.49266,1.46729,8.13468,3.27728,8.13468s3.27729-3.642,3.27729-8.13468a13.9907,13.9907,0,0,0-.74974-4.19782Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#ed7342"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M701.76776,527.54413l2.0405-.43725a26.26669,26.26669,0,0,0,1.10277-2.74761l-.937-.09969,1.04474-.22386c.37881-1.16111.55615-1.954.55615-1.954a25.173,25.173,0,0,0-7.36059,3.071l-.5611,2.61843-.219-2.05857a10.62774,10.62774,0,0,0-1.00473.87977c-3.17679,3.1768-4.71456,6.78962-3.4347,8.06948s4.89269-.25791,8.06948-3.4347a13.99068,13.99068,0,0,0,2.43816-3.49845Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#ed7342"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M702.51307,544.92845c-4.73171.30267-9.8874-.0176-15.37219,0V532.37089a55.40742,55.40742,0,0,0,15.37219,0Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.81579,
    cy: 539.34904,
    rx: 6.12146,
    ry: 5.15252,
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M890.19,720.98049c-64.01,91.42-170.12,151.2-290.19,151.2-121.51,0-228.72-61.22-292.47-154.5,54.9-104.35,166.37-78.5,292.47-78.5C727.42,639.1805,835.87,614.84047,890.19,720.98049Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#ed7342"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M600,664.1805c121.207,0,225.24512-22.01483,281.85815,67.19635q4.27332-5.61411,8.33179-11.39636c-54.31994-106.14-162.77-81.8-290.18994-81.8-126.1,0-237.57007-25.85-292.47,78.5q4.071,5.95678,8.3822,11.73211C373.276,640.78438,480.01318,664.1805,600,664.1805Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M600,874.67969a356.04078,356.04078,0,1,1,167.29492-41.60547A356.62661,356.62661,0,0,1,600,874.67969Zm0-709.99951a353.49979,353.49979,0,1,0,165.88477,665.7456A356.51758,356.51758,0,0,0,889.78125,720.68945a354.039,354.039,0,0,0,35.93652-340.105h0A353.211,353.211,0,0,0,600,164.68018Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M600,872.67969a354.41892,354.41892,0,0,1-354.5-354.5C245.5,322.708,404.52783,163.68018,600,163.68018c195.47168,0,354.5,159.02783,354.5,354.49951a352.22931,352.22931,0,0,1-63.90137,203.09082h0A355.09683,355.09683,0,0,1,600,872.67969Zm0-705.99951c-193.81787,0-351.5,157.68212-351.5,351.49951A351.52653,351.52653,0,0,0,888.1416,719.5498h0A349.24831,349.24831,0,0,0,951.5,518.17969C951.5,324.3623,793.81738,166.68018,600,166.68018Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 203.86066,
    r: 95.5,
    fill: "#ff6584"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 535.39077,
    cy: 163.5,
    r: 163.5,
    fill: "#ed7342"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M900.51225,81.11468A163.51275,163.51275,0,0,1,628.07291,254.1583,163.51409,163.51409,0,1,0,900.51225,81.11468Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "535.84 163.5 536.289 163.5 544.374 627.049 527.306 627.049 535.84 163.5",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 789.67099,
    y: 431.07808,
    width: 8.08516,
    height: 30.54396,
    transform: "translate(575.41119 -490.73056) rotate(62.23413)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M752.54365,633.79323s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.04365,
    cy: 586.1183,
    r: 7.08526,
    fill: "#ed7342"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 503.89077,
    y: 598.04945,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M845.54365,660.79323s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 598.04365,
    cy: 613.1183,
    r: 7.08526,
    fill: "#ed7342"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 596.89077,
    y: 625.04945,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M348.54365,666.79323s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.04365,
    cy: 619.1183,
    r: 7.08526,
    fill: "#ed7342"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 99.89077,
    y: 631.04945,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M808.54365,643.79323s.69056-14.46983,14.84712-12.78791",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 561.04365,
    cy: 596.1183,
    r: 7.08526,
    fill: "#ed7342"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 559.89077,
    y: 608.04945,
    width: 2,
    height: 14,
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M425.18508,236.33517l9.20569-7.36279c-7.15149-.789-10.08991,3.11127-11.29248,6.19836-5.587-2.31994-11.66919.72046-11.66919.72046l18.41888,6.68671A13.938,13.938,0,0,0,425.18508,236.33517Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M565.18508,311.33517l9.20569-7.36279c-7.15149-.789-10.08991,3.11127-11.29248,6.19836-5.587-2.31994-11.66919.72046-11.66919.72046l18.41888,6.68671A13.938,13.938,0,0,0,565.18508,311.33517Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M414.18508,375.33517l9.20569-7.36279c-7.15149-.789-10.08991,3.11127-11.29248,6.19836-5.587-2.31994-11.66919.72046-11.66919.72046l18.41888,6.68671A13.938,13.938,0,0,0,414.18508,375.33517Z",
    transform: "translate(-243.5 -26.81984)",
    fill: "#3f3d56"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M724,563.1805a116.42056,116.42056,0,0,1-9.73,46.75L506.9,506.01045l-15.77-7.82995,21.37-1.17005,185.21-10.12C715.34,507.3705,724,534.03047,724,563.1805Z",
    transform: "translate(-243.5 -26.81984)",
    opacity: 0.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "505.5 471.361 207.5 471.361 207.5 447.361 355.5 385.361 505.5 447.361 505.5 471.361",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorState);
export default __webpack_public_path__ + "static/media/ErrorState.bfad5084303deec84ecd9c2508c0941b.svg";
export { ForwardRef as ReactComponent };